import { CARD_TYPE_MAP, CardType } from './cardTypes';

/**
 * The singular, title cased name of each card type.
 */
export const TITLE_SINGULAR_BY_CARD_TYPE: Record<CardType, string> = {
  // Envelopes
  [CARD_TYPE_MAP.envelope]: 'Envelope',
  [CARD_TYPE_MAP.rsvpEnvelope]: 'RSVP Envelope',
  [CARD_TYPE_MAP.invitationEnvelope]: 'Invitation Envelope',
  // Add-ons
  [CARD_TYPE_MAP.paperAddOns]: 'Paper Add-on',
  [CARD_TYPE_MAP.bellyBand]: 'Belly Band',
  [CARD_TYPE_MAP.vellumJacket]: 'Vellum Jacket',
  [CARD_TYPE_MAP.waxSeal]: 'Wax Seal',
  // Primary card types
  [CARD_TYPE_MAP.matchingSuites]: 'Matching Suite',
  [CARD_TYPE_MAP.invitation]: 'Invitation',
  [CARD_TYPE_MAP.std]: 'Save the Date',
  [CARD_TYPE_MAP.dstd]: 'Digital Save the Date',
  [CARD_TYPE_MAP.ctd]: 'Change the Date',
  [CARD_TYPE_MAP.thankyou]: 'Thank You',
  [CARD_TYPE_MAP.menu]: 'Menu',
  [CARD_TYPE_MAP.program]: 'Program',
  [CARD_TYPE_MAP.place]: 'Place Card',
  [CARD_TYPE_MAP.details]: 'Enclosure',
  [CARD_TYPE_MAP.enclosure]: 'Enclosure',
  [CARD_TYPE_MAP.holiday]: 'Holiday Card',
  [CARD_TYPE_MAP.weddingShower]: 'Wedding Shower Invitation',
  [CARD_TYPE_MAP.napkin]: 'Napkin',
  [CARD_TYPE_MAP.signage]: 'Sign',
  [CARD_TYPE_MAP.sticker]: 'Sticker',
  [CARD_TYPE_MAP.tableNumber]: 'Table Number',
  // Secondary card types
  [CARD_TYPE_MAP.rsvp]: 'RSVP',
} as const;

/**
 * Returns the singular, title cased name for a card type.
 */
export const getSingularTitleByCardType = (cardType?: CardType, isDigital?: boolean): string => {
  const updatedType = isDigital ? CARD_TYPE_MAP.dstd : cardType;
  return (updatedType && TITLE_SINGULAR_BY_CARD_TYPE[updatedType]) || '';
};
